import React from "react";
import FadeIn from "react-fade-in";
import Lottie from "react-lottie";
import './Loading.css';
import * as legoData from "./legoloading.json";
import * as doneData from "./doneloading.json";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: legoData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};
const defaultOptions2 = {
  loop: false,
  autoplay: true,
  animationData: doneData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

export default class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      done: undefined
    };
  }

  componentDidMount() {
    setTimeout(() => {
      fetch("https://jsonplaceholder.typicode.com/posts")
        .then(response => response.json())
        .then(json => {
          this.setState({ loading: true });
          setTimeout(() => {
            this.setState({ done: true });
          }, 1500);
        });
    }, 1700);
  }

  render() {
    return (
      <div>
        {!this.state.done ? (
          <FadeIn>
            <div className="loading">
              <h1>WelCome To RishiQuote !!</h1>
              <h2>رشی کوٹ میں آپ کا استقبال ہے !!</h2>
              <div className="lottie">
              {!this.state.loading ? (
                <Lottie options={defaultOptions} height={150} width={150} />
              ) : (
                <Lottie options={defaultOptions2} height={150} width={150} />
              )}
              </div>
            </div>
          </FadeIn>
        ) : (
          <h1></h1>
        )}
      </div>
    );
  }
}
